export default __webpack_public_path__ + "static/media/editorIcon.c25e0d0e.svg";